import CryptoJS from "crypto-js";

export const generateKey = () => {
  return "retval_firstname"
  // return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
};

export const sha256Encrypt = (data: any) => {
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
};

export const encryptData = (key: string, data: any, method: string = 'POST') => {
  // 生成16字节的初始化向量
  const iv = CryptoJS.lib.WordArray.random(16);

  // 调试信息
  // console.log('=== encryptData 调试信息 ===');
  // console.log('原始数据类型:', typeof data);
  // console.log('原始数据:', data);
  // console.log('是否是FormData:', data instanceof FormData);
  // console.log('是否是URLSearchParams:', data instanceof URLSearchParams);
  // console.log('是否有append方法:', data && typeof data === 'object' && 'append' in data);
  // console.log('method:', method);

  // 根据数据类型和method进行不同的处理
  let dataToEncrypt: string;

  if (method === 'POST' || method === 'PUT') {
    if (typeof data === 'string') {
      // 如果是字符串（如application/x-www-form-urlencoded），直接使用
      dataToEncrypt = data;
    } else if (data instanceof FormData) {
      // 如果是FormData类型，手动转换为form格式字符串
      const formEntries: string[] = [];
      const formData = data as any;
      if (formData.entries) {
        for (const [key, value] of formData.entries()) {
          formEntries.push(`${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`);
        }
      }
      dataToEncrypt = formEntries.join('&');
    } else if (data instanceof URLSearchParams) {
      // 如果是URLSearchParams，直接转换为字符串
      dataToEncrypt = data.toString();
    } else {
      // 如果是对象或其他类型，使用JSON.stringify
      dataToEncrypt = JSON.stringify(data);
    }
  } else {
    // GET请求直接使用字符串
    dataToEncrypt = String(data);
  }

  const encrypted = CryptoJS.AES.encrypt(
    dataToEncrypt,
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv
    }
  );
  // 将IV和密文组合返回
  return iv.toString() + encrypted.toString();
};

export const decryptData = (key: string, encryptedStr: string) => {
  // 提取IV（前32个字符，因为IV是16字节，转换为hex是32个字符）
  const iv = CryptoJS.enc.Hex.parse(encryptedStr.substring(0, 32));
  const ciphertext = encryptedStr.substring(32);

  const decrypted = CryptoJS.AES.decrypt(
    ciphertext,
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv
    }
  );
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedStr
}; 